import { jsx as _jsx } from "react/jsx-runtime";
import { DialogView } from 'widgets/device.add/ui';
export const new_devices_routes = [
    {
        path: '/new-device',
        element: _jsx(DialogView, {}),
    },
];
